<template>
  <b-overlay :show="isLoading">
    <b-row>
      <b-col cols="12">
        <b-card>
          <h1 class="mb-3">ایجاد پلن VIP جدید</h1>

          <b-row>
            <b-col cols="12" md="6">
              <b-form-group label="عنوان پلن VIP" label-for="title">
                <b-form-input
                  v-model="newVipPlanDetails.title"
                  id="title"
                  trim
                  placeholder="پلن شش ماهه"
                />
              </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
              <b-form-group label="قیمت پلن" label-for="price">
                <b-input-group size="lg" append="تومان">
                  <b-form-input
                    v-model="newVipPlanDetails.price"
                    id="price"
                    trim
                    type="number"
                    placeholder="200000"
                  />
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <b-form-group label="مدت زمان پلن" label-for="month">
                <b-input-group size="lg" append="ماه">
                  <b-form-input
                    v-model="newVipPlanDetails.month"
                    id="month"
                    trim
                    type="number"
                    placeholder="6"
                  />
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" md="4">
              <b-form-checkbox
                switch
                v-model="newVipPlanDetails.hasMidnightReserve"
              >
                آیا پلن رزرو نیمه شب دارد؟
              </b-form-checkbox>
            </b-col>
            <b-col cols="12" md="4">
              <b-form-checkbox
                switch
                v-model="newVipPlanDetails.hasMasterReserve"
              >
                آیا پلن رزرو ساعت خاص با اساتید دارد؟
              </b-form-checkbox>
            </b-col>
            <b-col cols="12" md="4">
              <b-form-checkbox
                switch
                v-model="newVipPlanDetails.hasFridayReserve"
              >
                آیا پلن رزرو جمعه دارد؟
              </b-form-checkbox>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <small>خلاصه دوره</small>
              <quillEditor
                v-model="newVipPlanDetails.description"
                class="mb-1"
                style="margin-top: 3px"
                :options="editorOption"
              />
            </b-col>
            <b-col cols="12" v-if="loyaltyLite && loyaltyLite.length > 0">
              <b-row class="mb-1">
                <b-col cols="4">سطح وفاداری</b-col>
                <b-col cols="4">آیا فعال باشد؟</b-col>
                <b-col cols="4">درصد تخفیف</b-col>
                <b-col cols="12">
                  <hr />
                </b-col>
              </b-row>
              <b-row
                class="mb-1"
                v-for="(item, index) in loyaltyLite"
                :key="index"
              >
                <b-col cols="4">{{ item.title }}</b-col>
                <b-col cols="4">
                  <b-form-checkbox switch v-model="item.isActive">
                    آیا تخفیف فعال باشد؟
                  </b-form-checkbox>
                </b-col>
                <b-col cols="4">
                  <b-form-group label="" label-for="month">
                    <b-input-group size="sm" append="%">
                      <b-form-input
                        :disabled="!item.isActive"
                        v-model="item.percent"
                        id="month"
                        trim
                        type="number"
                        placeholder="6"
                      />
                    </b-input-group>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-col>
            <b-col cols="12">
              <b-form-checkbox switch v-model="newVipPlanDetails.isActive">
                آیا پلن فعال باشد؟
              </b-form-checkbox>
            </b-col>
            <b-col cols="12">
              <div class="d-flex align-items-center justify-content-end">
                <b-button
                  @click="sendVipPlanCreateRequest"
                  type="button"
                  variant="success"
                >
                  ایجاد پلن
                </b-button>
              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </b-overlay>
</template>
<script>
export default {
  mounted() {
    this.getAllLoyaltyDiscounts();
  },
  data() {
    return {
      isLoading: false,
      newVipPlanDetails: {
        id: 0,
        title: null,
        price: null,
        month: null,
        isActive: true,
        description: null,
        hasMidnightReserve: false,
        hasMasterReserve: false,
        hasFridayReserve: false,
        vipUserDiscounts: [],
      },
      loyaltyLite: null,
      editorOption: {
        // Some Quill options...
        theme: "snow",
        modules: {
          toolbar: [
            ["bold", "italic", "underline", "strike"],
            ["blockquote", "code-block"],
            [{ header: 1 }, { header: 2 }],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ script: "sub" }, { script: "super" }],
            [{ indent: "-1" }, { indent: "+1" }],
            [{ direction: "rtl" }],
            [{ size: ["small", false, "large", "huge"] }],
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            [{ font: [] }],
            [{ color: [] }, { background: [] }],
            [{ align: [] }],
            ["clean"],
            ["link", "image", "video"],
          ],
        },
      },
    };
  },
  methods: {
    async getAllLoyaltyDiscounts() {
      try {
        this.isLoading = true;
        let _this = this;
        let getAllScheduleLoyaltyTitlesLite =
          new GetAllScheduleLoyaltyTitlesLite(_this);
        await getAllScheduleLoyaltyTitlesLite.fetch((res) => {
          _this.loyaltyLite = null;
          res.forEach((item) => (item["isActive"] = false));
          _this.loyaltyLite = res;
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    async sendVipPlanCreateRequest() {
      try {
        this.newVipPlanDetails.vipUserDiscounts = [];
        this.loyaltyLite.forEach((item) => {
          if (item.isActive) {
            this.newVipPlanDetails.vipUserDiscounts.push({
              scheduleLoyaltyDiscountTitleId: item.id,
              percent: item.percent,
            });
          }
        });
        this.isLoading = true;
        let _this = this;
        let createVipUserPlan = new CreateVipUserPlan(_this);
        createVipUserPlan.setRequestParamDataObj(_this.newVipPlanDetails);
        await createVipUserPlan.fetch((res) => {
          if (res.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "ایجاد شد!",
                icon: "CheckIcon",
                variant: "success",
                text: "پلن با موفقیت ایجاد شد!",
              },
            });
            _this.newVipPlanDetails = {
              id: 0,
              title: null,
              price: null,
              month: null,
              isActive: true,
              description: null,
              hasMidnightReserve: false,
              hasMasterReserve: false,
              hasFridayReserve: false,
            };
            _this.getAllLoyaltyDiscounts();
          } else {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "ایجاد نشد!",
                icon: "XIcon",
                variant: "danger",
                text: res.message || "مشکلی پیش آمد، لطفا دوباره امتحان کنید",
              },
            });
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  components: {
    BCard,
    BRow,
    BCol,
    BFormCheckbox,
    BFormGroup,
    BFormInput,
    BButton,
    BOverlay,
    BInputGroup,
    quillEditor,
  },
};
import {
  BCard,
  BRow,
  BCol,
  BFormCheckbox,
  BFormGroup,
  BFormInput,
  BButton,
  BOverlay,
  BInputGroup,
} from "bootstrap-vue";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";
import { CreateVipUserPlan } from "@/libs/Api/VipUser";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { GetAllScheduleLoyaltyTitlesLite } from "@/libs/Api/ScheduleLoyaltyDiscountTitle";
</script>
